const s = (e, o) => e === o || !(e === e || o === o);
export {
  s as sameValue
};
